
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { BackOrderEditModalViewStore } from 'application/pick-ticket/stores';
import { BackOrderEditModalTemplate } from 'themes/application/pick-ticket/components';

@setCurrentView((rootStore, componentProps) => new BackOrderEditModalViewStore(rootStore, componentProps), 'backOrderEditModalViewStore')
@observer
class BackOrderEditModal extends React.Component {
    render() {
        return <BackOrderEditModalTemplate {...this.props} />
    }
}

export default BackOrderEditModal;
